// extracted by mini-css-extract-plugin
module.exports = {"comments":"Comments_comments__2ycUG"};